import React from "react";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import "./SearchInput.scss";
import { ISearchInputProps } from "./SearchInput.types";

export const SearchInput: React.FC<ISearchInputProps> = ({
  value,
  onChange,
  ...inputProps
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <div className="search-container">
      <div className="search-icon-wrapper">
        <SearchIcon />
      </div>
      <InputBase
        className="styled-input-base"
        placeholder="Search..."
        inputProps={{ "aria-label": "search" }}
        value={value}
        onChange={handleChange}
        {...inputProps}
      />
    </div>
  );
};
